import React from "react";
import { AicoConnection, PageHeader } from "../../Components";
import { ButtonTypes, TableStyles_Types } from "../../Definitions";
import { colors, frames, glyphs } from "../../Styles";
import { LoadingSpinner } from "../../Services/wrapper";
import { ReactiveTable } from "../../Components/Tables/reactiveTableRenderer";
import {
	getCoreRowModel,
	getFilteredRowModel,
	getSortedRowModel,
	useReactTable,
} from "@tanstack/react-table";
import { GenericRow, useColumnConstructor } from "../Tables/_Tables/useColumnConstructor";
import NewButton from "../BaseComponents/newButton";

interface GenericDeviceTableProps<T extends GenericRow> {
	title: string;
	subTitle?: string;
	columnsData: any[];
	data?: T[];
	loading: boolean;
	error?: any;
	onFetch: () => void;
	tabButtons?: JSX.Element[]
}

export function GenericDeviceTable<T extends GenericRow>({
	title,
	subTitle,
	columnsData,
	data = [],
	loading,
	error,
	onFetch,
	tabButtons,
}: GenericDeviceTableProps<T>) {
	const columns = useColumnConstructor({
		accessorData: columnsData,
		tableStyle: TableStyles_Types.primaryTable,
		canEdit: false,
	});

	const table = useReactTable({
		columns,
		data,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
	});

	return (
		<frames.Page_inner>
				<PageHeader topHeader="Device Data Tables" subHeader={subTitle || title} />

			<frames._page_inner_content>
				<frames._grid_topBtns_outer>
					<frames._grid_topBtns_inner style={{ position: "relative", justifyContent: "end", gap:"5px" }}>
						<div style={{ position: "absolute", top: "50%", transform: "translateY(-50%)", left: "20px" }}>
							<AicoConnection/>
						</div>
						{tabButtons && <>{tabButtons}</>}
						<NewButton
							content="fetch"
							buttonType={ButtonTypes.tableButton}
							startEnhancer={glyphs.Fetch({})}
							onClick={onFetch}
							disabled={loading}
						/>
					</frames._grid_topBtns_inner>

					<div
						style={{
							gridArea: "2/1/3/2",
							border: "5px solid " + colors.greyPrimary,
							overflow: "hidden",
							borderRadius: "10px",
							backgroundColor: colors.greyLightTertiary,
						}}
					>
						{loading ? (
							<LoadingSpinner />
						) : error ? (
							<div style={{ color: "#aa0000" }}>Error</div>
						) : (
							<ReactiveTable
								table={table}
								tableType={TableStyles_Types.primaryTable}
								emptyText="No data found"
								renderFooter={false}
							/>
						)}
					</div>
				</frames._grid_topBtns_outer>
			</frames._page_inner_content>
		</frames.Page_inner>
	);
}
